<template>
  <el-form
    ref="addFrom"
    :model="addFrom"
    :rules="rules"
    label-width="120px"
    class="userManage-from"
  >
    <el-form-item label="课题属性" prop="courseGroup">
      <el-select
        ref="courseGroup"
        v-model="addFrom.courseGroup"
        placeholder="请选择课题属性"
        clearable
        filterable
        size="small"
        style="width: 200px"
        class="filter-item"
        @change="handleChangeKtsx"
      >
        <el-option
          v-for="item in groupOptions"
          :key="item.dictValue"
          :label="item.dictLabel"
          :value="item.dictValue"
        />
      </el-select>
    </el-form-item>

    <el-form-item
      label="项目类型"
      prop="courseProject"
      key="1"
      v-if="xmlxActive"
    >
      <el-select
        ref="courseProject"
        v-model="addFrom.courseProject"
        placeholder="请选择项目类型"
        filterable
        size="small"
        style="width: 200px"
        class="filter-item"
      >
        <el-option
          v-for="item in projectOptions"
          :key="item.dictValue"
          :label="item.dictLabel"
          :value="item.dictValue"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="所属阶段" prop="step">
      <el-select
        ref="step"
        v-model="addFrom.step"
        placeholder="请选择所属阶段"
        clearable
        filterable
        size="small"
        style="width: 200px"
        class="filter-item"
      >
        <el-option
          v-for="item in stepOptions"
          :key="item.dictValue"
          :label="item.dictLabel"
          :value="item.dictValue"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="阶段表单名" prop="fromTitle">
      <el-input
        placeholder="请输入表单名"
        v-model="addFrom.fromTitle"
      ></el-input>
    </el-form-item>

    <el-form-item label="是否启用" prop="isUse">
      <el-switch
        v-model="addFrom.isUse"
        active-value="1"
        inactive-value="0"
      ></el-switch>
    </el-form-item>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getDictData } from "@/api/task.js";
import { listMeta, getMeta, saveMeta } from "@/api/meta.js";

export default {
  name: "add",
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      addFrom: {
        courseGroup: null,
        courseProject: null,
        step: null,
        fromTitle: null,
        isUse: null,
      },

      rules: {
        courseGroup: [
          { required: true, message: "课题属性不能为空", trigger: "change" },
        ],
        courseProject: [
          { required: true, message: "项目类型不能为空", trigger: "change" },
        ],
        step: [
          { required: true, message: "课题阶段不能为空", trigger: "change" },
        ],
        fromTitle: [
          { required: true, message: "表单名不能为空", trigger: "blur" },
        ],
      },

      groupOptions: [],
      stepOptions: [],
      projectOptions: [],
      parentDialog: false,
      xmlxActive: false,
    };
  },
  created() {
    //课题属性
    getDictData("pmp_course_group", 1).then((res) => {
      if (res.code === 0) {
        this.groupOptions = res.data;
      }
    });

    //项目类型
    getDictData("pmp_course_project", 1).then((res) => {
      if (res.code === 0) {
        this.projectOptions = res.data;
      }
    });

    //所属阶段
    getDictData("pmp_course_step", 1).then((res) => {
      if (res.code === 0) {
        // this.stepOptions = res.data;
        let temp = res.data.filter(
          (ele) =>
            ele.dictLabel.indexOf("申请") != -1 ||
            ele.dictLabel.indexOf("延迟结项") != -1
        );
        for (let i in temp) {
          if (temp[i].dictLabel == "中期检查申请") {
            temp[i].dictValue = "4";
          }
        }
        this.stepOptions = temp;
      }
    });
  },
  methods: {
    saveForm() {
      this.$refs["addFrom"].validate((valid) => {
        if (valid) {
          saveMeta(this.addFrom).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("getParentForm");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },

    handleChangeKtsx(e) {
      if (e == 3) {
        this.xmlxActive = true;
      } else {
        this.xmlxActive = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 55px;
}
.table {
  .table-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    > div {
      width: 20%;
      display: flex;
      justify-content: center;
      > div {
        color: #036eb8;
        padding: 0 10px;
        font-size: 25px;
        cursor: pointer;
      }
    }
    > div:nth-of-type(2) {
      width: 40%;
    }
  }
  .table-none {
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  .table-body {
    .table-tr {
      display: flex;
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #f2f2f2;
      // border-left: 1px solid #f2f2f2;
      .table-td {
        display: flex;
        justify-content: center;
        width: 20%;
        // border-right: 1px solid #f2f2f2;
      }
      .table-td:nth-of-type(2) {
        width: 40%;
      }
      .del {
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
</style>